<template>
    <div class="box">
        <h2>
            Einstellungen für den Tarifrechner des MietkautionsDepot
        </h2>
        <div class="body">
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="zins_sicherheit" name="zins_sicherheit" v-validate="'required|decimal'" id="zins_sicherheit" placeholder=" " type="text" />
                <label for="zins_sicherheit">Zins Sicherheit in %</label>
                <span class="error" v-show="errors.has('zins_sicherheit')">{{ errors.first("zins_sicherheit") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="zins_chance" name="vision_top_p" v-validate="'required|decimal'" id="zins_chance" placeholder=" " type="text" />
                <label for="zins_chance">Zins Chance in %</label>
                <span class="error" v-show="errors.has('zins_chance')">{{ errors.first("zins_chance") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="einmalige_kosten" name="einmalige_kosten" v-validate="'required|decimal'" id="einmalige_kosten" placeholder=" " type="text" />
                <label for="einmalige_kosten">Einmalige Kosten in %</label>
                <span class="error" v-show="errors.has('einmalige_kosten')">{{ errors.first("einmalige_kosten") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="beitragssatz_miete" name="beitragssatz_miete" v-validate="'required|decimal'" id="beitragssatz_miete" placeholder=" " type="text" />
                <label for="beitragssatz_miete">Beitragssatz Miete in %</label>
                <span class="error" v-show="errors.has('beitragssatz_miete')">{{ errors.first("beitragssatz_miete") }}</span>
            </div>
            <hr />
            <div class="button-row">
                <button @click="save()" type="button" class="primary size-l"><i class="fal fa-save"></i> Speichern</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            zins_sicherheit: 2.65,
            zins_chance: 5.0,
            einmalige_kosten: 3.0,
            beitragssatz_miete: 1.6
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        save() {
            var settings = {
                zins_sicherheit: 0,
                zins_chance: 0,
                einmalige_kosten: 0,
                beitragssatz_miete: 0
            };

            settings.zins_sicherheit = parseFloat(this.zins_sicherheit) / 100;
            settings.zins_chance = parseFloat(this.zins_chance) / 100;
            settings.einmalige_kosten = parseFloat(this.einmalige_kosten) / 100;
            settings.beitragssatz_miete = parseFloat(this.beitragssatz_miete) / 100;

            this.$api.put("/mietkautionsdepot/tarifrechner", settings).then(
                () => {
                    this.$snotify.success("Einstellungen gespeichert");
                },
                () => {
                    this.$snotify.error("Speichern fehlgeschlagen");
                }
            );
        },
        fetchData() {
            this.$api.get("/mietkautionsdepot/tarifrechner").then(
                response => {
                    if (response.data.data === null) {
                        response.data.data = {
                            zins_sicherheit: 0.0265,
                            zins_chance: 0.05,
                            einmalige_kosten: 0.03,
                            beitragssatz_miete: 0.016
                        };
                    }

                    this.zins_sicherheit = response.data.data.zins_sicherheit * 100;
                    this.zins_chance = response.data.data.zins_chance * 100;
                    this.einmalige_kosten = response.data.data.einmalige_kosten * 100;
                    this.beitragssatz_miete = response.data.data.beitragssatz_miete * 100;
                },
                () => {
                    this.$snotify.error("Fehler beim Laden der Einstellungen");
                }
            );
        }
    }
};
</script>
